'use strict';

var _ = require('lodash');
var bp = require('../util/breakpoints');

/**
 * Start sticky header
 *
 * @param {String} selector - Classes to select the elements that will be sticky
 * @param {Boolean} isDoubleSticky - Informs if we will have more than one sticky element
 */
function initSticky(selector, isDoubleSticky) {
    $(selector).stick_in_parent({
        parent: 'body',
        spacer: false
    }).on('sticky_kit:stick', function (e) {
        var $el = $(e.target);
        var isHeader = $el.hasClass('js-sticky-header');

        if (isHeader) {
            $el.addClass('shadow-sm');
        }

        if (isHeader && isDoubleSticky && $('.js-promo-banner').hasClass('is_stuck')) {
            $el.css({ top: $('.js-promo-banner').outerHeight() });
        }
    }).on('sticky_kit:unstick', function (e) {
        var $el = $(e.target);
        $el.removeClass('shadow-sm');
    });
}

module.exports = {
    init: function () {
        $('body').on('stickyHeader:start', function () {
            var isStickyHeaderEnabled = $('input[name="isStickyHeaderEnabled"]').val() === 'true';
            var isStickyPromoBannerEnabled = $('input[name="isStickyPromoBannerEnabled"]').val() === 'true';

            if (isStickyHeaderEnabled) {
                var $window = $(window);

                if ($window.width() <= bp.values.small) {
                    if (isStickyPromoBannerEnabled) {
                        initSticky('.js-sticky-header, .js-promo-banner', true);
                    } else {
                        initSticky('.js-sticky-header', false);
                    }
                }

                $window.on('resize', _.debounce(function () {
                    if ($window.width() <= bp.values.small) {
                        if (!$('.js-search-container').is(':visible')) {
                            if (isStickyPromoBannerEnabled) {
                                initSticky('.js-sticky-header, .js-promo-banner', true);
                            } else {
                                initSticky('.js-sticky-header', false);
                            }
                        }
                    } else {
                        $('.js-sticky-header, .js-promo-banner').trigger('sticky_kit:detach');
                        $('.js-sticky-header').removeClass('shadow-sm');
                    }
                }, 200));
            }
        });

        $('body').trigger('stickyHeader:start');
    }
};
